import { useState, useEffect, useRef, useCallback } from 'react';
import { toPng } from 'html-to-image';
import useStore from '../../../store'; // Проверь правильность пути к store в твоем проекте

/**
 * Универсальный хук для шеринга скриншотов мини-игр
 * Берет на себя: скрытие UI, генерацию картинки, отправку на сервер и вызов окна Telegram.
 */
export function useArcadeShare(socket) {
  const boardRef = useRef(null);
  const[isSharing, setIsSharing] = useState(false);
  const [isCapturing, setIsCapturing] = useState(false); // Флаг для временного скрытия меню результатов

  // Слушаем ответ от сервера с готовым ID сообщения
  useEffect(() => {
    if (!socket) return;

    const handleShareEvent = (data) => {
      if (data.type === 'share_ready') {
        setIsSharing(false);
        try {
          window.Telegram?.WebApp?.shareMessage(data.shareId);
        } catch (e) {
          console.error("Шеринг не поддерживается на этом клиенте:", e);
        }
      } else if (data.type === 'share_error') {
        setIsSharing(false);
        window.croco?.haptic?.('error');
      }
    };

    socket.on('arcade:event', handleShareEvent);
    return () => socket.off('arcade:event', handleShareEvent);
  }, [socket]);

  /**
   * Функция запуска шеринга
   * @param {Object} stats - статистика игры (очки, время, ранг)
   * @param {Object} options - настройки (цвет фона подложки, классы для скрытия со скриншота)
   */
  const share = useCallback((stats, options = {}) => {
    if (isSharing) return;
    setIsSharing(true);
    setIsCapturing(true); // Даем команду React'у спрятать оверлей результатов

    const {
        backgroundColor = '#121826', // Базовый темный фон, чтобы не было прозрачных краев
        ignoreClass = 'ignore-share' // Элементы с этим классом не попадут на скриншот (например, тултипы)
    } = options;

    // setTimeout нужен, чтобы React успел отрендерить DOM БЕЗ меню результатов (за 100мс)
    setTimeout(async () => {
      if (boardRef.current) {
        try {
          // Делаем снимок чистой доски
          const dataUrl = await toPng(boardRef.current, {
            backgroundColor,
            pixelRatio: 2, // Качество картинки (Retina)
            filter: (node) => {
              if (node?.classList?.contains) {
                return !node.classList.contains(ignoreClass);
              }
              return true;
            }
          });

          const base64Image = dataUrl.split(';base64,').pop();

          // Достаем userId из глобального стора
          const store = useStore.getState();
          const userId = String(store.ref.telegram.telegramUserId);

          // Отправляем системное событие на сервер
          store.ref.work.methods.hostAction('mafiaMiniGameAction', {
            type: 'share_result',
            userId,
            image: base64Image,
            stats: stats || {}
          });

        } catch (e) {
          console.error('Ошибка создания скриншота:', e);
          setIsSharing(false);
        }
      } else {
         setIsSharing(false);
      }

      // Возвращаем оверлей на место сразу после создания скриншота
      setIsCapturing(false);
    }, 1000);

  }, [isSharing]);

  return { boardRef, share, isSharing, isCapturing };
}